export const MESSAGE_SENT = 'MESSAGE_SENT';